"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init_experimental = void 0;
exports.init = init;
const InstantReactWebDatabase_ts_1 = __importDefault(require("./InstantReactWebDatabase.js"));
const version_js_1 = __importDefault(require("./version.js"));
/**
 *
 * The first step: init your application!
 *
 * Visit https://instantdb.com/dash to get your `appId` :)
 *
 * @example
 *  import { init } from "@instantdb/react"
 *
 *  const db = init({ appId: "my-app-id" })
 *
 *  // You can also provide a schema for type safety and editor autocomplete!
 *
 *  import { init } from "@instantdb/react"
 *  import schema from ""../instant.schema.ts";
 *
 *  const db = init({ appId: "my-app-id", schema })
 *
 *  // To learn more: https://instantdb.com/docs/modeling-data
 */
function init(config) {
    return new InstantReactWebDatabase_ts_1.default(config, {
        '@instantdb/react': version_js_1.default,
    });
}
/**
 * @deprecated
 * `init_experimental` is deprecated. You can replace it with `init`.
 *
 * @example
 *
 * // Before
 * import { init_experimental } from "@instantdb/react"
 * const db = init_experimental({  ...  });
 *
 * // After
 * import { init } from "@instantdb/react"
 * const db = init({ ...  });
 */
exports.init_experimental = init;
//# sourceMappingURL=init.js.map